/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React from 'react';

import Checkbox from '../../common/Checkbox';
import Tooltip from '../../common/tooltip';

const noSmsOriginatorMessage = 'Text message campaigns are disabled for your account because you do not have a dedicated sms originator number. Please contact support.';

const studioOwnerMessage = 'Upgrade your subscription to send text campaigns!\n'
  + 'Reach clients instantly, send promos, and fill your chair faster.  To upgrade, please contact support.';

const SelectMessageType = ({
  sendEmailChecked,
  sendSmsChecked,
  sendPushChecked,
  hasSmsOriginator,
  isStudioOwner,
  toggleSendEmail,
  toggleSendSms,
  toggleSendPush,
}) => (
  <div>
    <h2 className="c-heading">
      Select a Message Type(s)
    </h2>
    <p className="epsilon u-type--light">
      How would you like to reach your client?
    </p>
    <div className="layout layout--small layout--auto u-mt" display-if={isStudioOwner || !hasSmsOriginator}>
      <div className="layout__item">
        <p className="epsilon u-type--light">
          Text message campaigns are disabled for your account.
        </p>
      </div>
      <div className="layout__item">
        <Tooltip
          text={isStudioOwner ? studioOwnerMessage : noSmsOriginatorMessage}
        />
      </div>
    </div>
    <div className="layout layout--small layout--auto u-mt">
      <div className="layout__item">
        <Checkbox checked={sendEmailChecked} onChange={toggleSendEmail}>
          <span>Email</span>
        </Checkbox>
      </div>
      <div className="layout__item" display-if={hasSmsOriginator && !isStudioOwner}>
        <Checkbox checked={sendSmsChecked} onChange={toggleSendSms}>
          <span>Text Message</span>
        </Checkbox>
      </div>
      <div className="layout__item">
        <Checkbox checked={sendPushChecked} onChange={toggleSendPush}>
          <span>Push Notification</span>
        </Checkbox>
      </div>
    </div>
  </div>
);
SelectMessageType.propTypes = {
  sendEmailChecked: PropTypes.bool,
  sendSmsChecked: PropTypes.bool,
  sendPushChecked: PropTypes.bool,
  hasSmsOriginator: PropTypes.bool,
  isStudioOwner: PropTypes.bool,
  toggleSendEmail: PropTypes.func,
  toggleSendSms: PropTypes.func,
  toggleSendPush: PropTypes.func,
};
SelectMessageType.defaultProps = {
  sendEmailChecked: false,
  sendSmsChecked: false,
  sendPushChecked: false,
  hasSmsOriginator: false,
  isStudioOwner: false,
  toggleSendEmail: () => null,
  toggleSendSms: () => null,
  toggleSendPush: () => null,
};

export default SelectMessageType;
